export default __webpack_public_path__ + "images/95046d021c77da65ae3c4d66b61608c2.svg";